import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'translatePipe',
})
export class TranslatePipe implements PipeTransform {
  transform(value: string): string {
    return (
      {
        submit: '售后申请待商家处理',
        refusalOfRefund: '商家拒绝退款',
        waitingForDelivery: '待买家退货',
        goodsToBeReceived: '待商家确认收货',
        agreeToRefund: '商家同意退款',
        refusalOfGoods: '商家拒绝收货',
        confirmReceiptAndDelivery: '待买家收货',
        successfulRefund: '退款成功',
        complete: '售后完成',
        cancel: '售后关闭',
        refundOnSale: '售中退款',
        refundAfterSale: '售后退款',
        merchantVoluntaryRefund: '商家主动退款',
        refundOnly: '仅退款',
        refundForReturnedGoods: '退货退款',
        exchangeGoods: '换货',
        codeError: '错误编码',
        noInformation: '无信息',
        pickUp: '快递收件',
        inTransit: '正在派件',
        signFor: '已签收',
        problemShipment: '派送失败',
        difficultItem: '疑难件',
        returnSignFor: '退件签收',
      }[value] || value
    );
  }
}
